import React from 'react';
import styles from './Card.module.css';

/**
 * Card Component
 *
 * A container component with elevation and optional padding variations.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card content
 * @param {'sm' | 'md' | 'lg' | 'none'} props.padding - Padding size
 * @param {boolean} props.hoverable - Enable hover effect
 * @param {string} props.className - Additional CSS classes
 *
 * @example
 * <Card padding="md" hoverable>
 *   <h3>Card Title</h3>
 *   <p>Card content goes here</p>
 * </Card>
 */
const Card = ({
  children,
  padding = 'md',
  hoverable = false,
  className = '',
  ...props
}) => {
  const classNames = [
    styles.card,
    styles[`padding-${padding}`],
    hoverable && styles.hoverable,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};

export default Card;
